<template>
  <section class="winners-2019-photos">
    <div class="container">
      <div class="grid-box">
        <h2 class="winners-2019-title">ГРАНД ФИНАЛ В МОСКВЕ</h2>
        <div class="winners-2019-photos__main">
          <p class="winners-2019-photos__text">
            Турнир топ уровня, для желающих стать частью большого
            киберспорта.<br />
            В каждом новом раунде - серьезное испытание: уровень команд
            становится значительно выше. Участники, прошедшие в финальные стадии
            турнира, регулярно показывают достойные результаты на крупных
            турнирах и квалификациях.
          </p>
          <div class="winners-2019-photos__list row">
            <div
              v-for="(image, index) in images"
              :key="index"
              class="col-12 col-md-6 col-lg-4"
            >
              <div class="winners-2019-photos__photo">
                <div class="winners-2019-photos__photo_wrap">
                  <img :src="image.src" alt @click="openImg(image.src)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import showImage from "@/services/common/showImage";
export default {
  name: "Winners2019Photos",
  data: () => ({
    images: [
      {
        src: require("@/assets/img/photos/1.jpg")
      },
      {
        src: require("@/assets/img/photos/2.jpg")
      },
      {
        src: require("@/assets/img/photos/3.jpg")
      },
      {
        src: require("@/assets/img/photos/4.jpg")
      },
      {
        src: require("@/assets/img/photos/5.jpg")
      },
      {
        src: require("@/assets/img/photos/6.jpg")
      }
    ]
  }),
  methods: {
    openImg(src) {
      showImage(src);
    }
  }
};
</script>

<style lang="scss">
.winners-2019-photos {
  margin-top: 20px;
  &__main {
    text-align: center;
    padding: 40px 70px 60px;
    background: linear-gradient(180deg, rgba(#1e2135, 0.4), rgba(#304d96, 0.4));
    border-radius: 6px;
  }

  &__text {
    font-size: 18px;
    line-height: 150%;
    margin-bottom: 38px;
    font-weight: 400;
  }

  &__photo {
    position: relative;
    max-width: 100%;
    width: 780px;

    &:before {
      display: block;
      content: "";
      width: 100%;
      padding-top: 66%;
    }

    &_wrap {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.5);
    }

    img {
      cursor: pointer;
      transition: 0.3s transform;
      max-width: 100%;

      &:hover {
        // filter: brightness(1.15);
        transform: scale(1.02);
      }
    }
  }

  @include breakpoint("sm-and-down") {
    &__text {
      font-size: 16px;
    }
    &__main {
      padding: 30px 20px 40px;
    }
  }

  @include breakpoint("xs-only") {
    &__main {
      padding: 20px 15px 30px;
    }
  }
}
</style>
